// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__UtynX","list":"styles_list__oyopi"};